import {Pipe, PipeTransform} from '@angular/core';
/**
 * Created by Rumyantsev Daniil on 04.05.2018.
 */

@Pipe({name: 'wrap'})
export class WrapperPipe implements PipeTransform {

  transform(value: any, prefix?: string, postfix?: string): string {

    if( value == null || value == '') {
      return "";
    }

    if(prefix != undefined) {
      prefix += ' ';
    }

    if(postfix != undefined) {
      postfix = ' ' + postfix;
    }

    return prefix + value + postfix;
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/wrapper.pipe.ts